<script setup lang="ts">
import { cn } from '@/lib/utils';
import {
  DialogClose,
  DialogContent,
  DialogOverlay,
  DialogPortal,
  useForwardPropsEmits,
  type DialogContentEmits,
  type DialogContentProps,
} from 'reka-ui';
import { computed, type HTMLAttributes } from 'vue';

const props = defineProps<DialogContentProps & { class?: HTMLAttributes['class'] }>();
const emits = defineEmits<DialogContentEmits>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;
  return delegated;
});
const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
  <DialogPortal>
    <DialogOverlay class="fixed inset-0 z-50 bg-black/60" />
    <DialogContent
      v-bind="forwarded"
      :class="
        cn(
          'fixed top-1/2 left-1/2 z-50 grid w-full max-w-[calc(100%-2rem)] -translate-x-1/2 -translate-y-1/2 gap-4 rounded-lg border border-border bg-background p-6 text-foreground shadow-lg sm:max-w-lg',
          props.class,
        )
      "
    >
      <slot />
      <DialogClose
        class="absolute top-3 right-3 grid h-7 w-7 cursor-pointer place-items-center rounded-md border-0 bg-transparent text-muted-foreground opacity-80 hover:bg-muted hover:opacity-100 focus-visible:ring-2 focus-visible:ring-ring"
        aria-label="Close"
      >
        ✕
      </DialogClose>
    </DialogContent>
  </DialogPortal>
</template>
